
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91file_id_93MqZVlPlJSoMMIOZ4KDc0ihFnz3tF6mADbwKDL6BbAtoMeta } from "/tmp/build_5b96a0a9/pages/all/[file_id].vue?macro=true";
import { default as allF7H13m353bRLTeFDfG2ud0YYtAAi58HwEFTy3PWG6_45gMeta } from "/tmp/build_5b96a0a9/pages/all.vue?macro=true";
import { default as indexrUK2ee_aYRYxqC99y2UgDRZac_4OJUOkL9bkhSfReCQMeta } from "/tmp/build_5b96a0a9/pages/home/index.vue?macro=true";
import { default as _91file_id_93n8yPS2lCy7jgjSCpBaouxYIxF9gXfWGPtEj2iuwrtPIMeta } from "/tmp/build_5b96a0a9/pages/home/on-this-day/files/[file_id].vue?macro=true";
import { default as on_45this_45dayoqjCFtLTDHTeGSNV8CKxXCy3ZrJQdmrudOYP8qBRIXoMeta } from "/tmp/build_5b96a0a9/pages/home/on-this-day.vue?macro=true";
import { default as _91file_id_93YuzssgCeFXVXqKueWiZG_xbDVrjwQc2LgXVOv_V1akoMeta } from "/tmp/build_5b96a0a9/pages/home/recent-days/files/[file_id].vue?macro=true";
import { default as recent_45daysEKpEu9WiLdbEyYsDxxRQZYXfZPjiBtmCG5vA1_J3b1gMeta } from "/tmp/build_5b96a0a9/pages/home/recent-days.vue?macro=true";
import { default as _91file_id_93OC1F8q3blLNziIzeRF2XoIfg8LAkqCOgDej4pbRx_UgMeta } from "/tmp/build_5b96a0a9/pages/home/favorites/[file_id].vue?macro=true";
import { default as homelrma2NC5Bh2pNtb1_PWm3NRBhX3QyR9tuavc3reWrSYMeta } from "/tmp/build_5b96a0a9/pages/home.vue?macro=true";
import { default as index2lg8qu_kDpykCCtHE59zs1xGRb47clF3Q6eVCvsjQwwMeta } from "/tmp/build_5b96a0a9/pages/index.vue?macro=true";
import { default as gallery_45oNXgnLAsXqR1xr7Mmt2f0fC8oRiZ6DlfYeZlRaZNbUMeta } from "/tmp/build_5b96a0a9/pages/gallery.vue?macro=true";
import { default as sign_inyUgoOPYA_459oma9V62eL_45lpTWrrHWBQ3pKva1U_45sxKYQMeta } from "/tmp/build_5b96a0a9/pages/sign_in.vue?macro=true";
import { default as welcomeMbFn0wHfKXXQ7ycYTAFr38DDdpOPtrEv2eeB1tDAlDYMeta } from "/tmp/build_5b96a0a9/pages/welcome.vue?macro=true";
import { default as projectsDlDUM1_45q_6soQErXPfMaFkSag7YwK_45OpUEOj6Okim7wMeta } from "/tmp/build_5b96a0a9/pages/projects.vue?macro=true";
import { default as indexIToekD7w4WXZZDAyk86CmbpZpv8Yk5P1uET0wbCFQFYMeta } from "/tmp/build_5b96a0a9/pages/groups/index.vue?macro=true";
import { default as indexHe_zj148C7yZu_45daL9EpW2nmjfhqJgTFQvXF_45xrAcMUMeta } from "/tmp/build_5b96a0a9/pages/delete-bin/index.vue?macro=true";
import { default as indexvvjABqlY0gdWHNICy87UKDkRide2hUmrKRW5EZXiob0Meta } from "/tmp/build_5b96a0a9/pages/connections/index.vue?macro=true";
import { default as _91_91id_93_93DyIoAWClDwUp2QfUtMukxz1ism_45bzO5M_45O8dIAVLH_450Meta } from "/tmp/build_5b96a0a9/pages/impersonate/[[id]].vue?macro=true";
import { default as framed_45photo_45printsVnLoODuv0voinTq6KlkqVqA_oWcgdiIP5Ks9j2IeSZYMeta } from "/tmp/build_5b96a0a9/pages/framed-photo-prints.vue?macro=true";
import { default as index1wYfmHCUQK5SH9NMOYxcPqlQbDSGhN9PfOc_45JKrGWm4Meta } from "/tmp/build_5b96a0a9/pages/notifications/index.vue?macro=true";
import { default as indexKu1bdH70b80J3RzO1Zc7TR6l_QMMM55M8Vz7rdggu48Meta } from "/tmp/build_5b96a0a9/pages/digitization-projects/index.vue?macro=true";
import { default as _91_91token_93_93UvYPeFyA_458xYeXK53c72oV2THdVRqQzVZ4rN5sV_wJ0Meta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/[[token]].vue?macro=true";
import { default as indexE_74Hd271Elmrpt8bkvPqIpKncB_JDtCjDQzYqwHUNYMeta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/tags/index.vue?macro=true";
import { default as indexL08TFl7uKtfZXqMFirVh_456SjAHqQEh5M0_45zMPo22_45IsMeta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/albums/index.vue?macro=true";
import { default as indexQGvPCllM9CEC2voCMYThYxLMGAgJXuzoDKaxwlwvLJwMeta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/people/index.vue?macro=true";
import { default as recentBeHqQbGas8VQwTx73TD_458XEJmxEmW3HT3NXUViq7q8IMeta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/albums/recent.vue?macro=true";
import { default as visited_hZh1r56Wf2AVnT0EB1sWWdJOeS8NnQaBJeV4OtYeXkMeta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/albums/visited.vue?macro=true";
import { default as _91file_id_93w3a7GSZZeoGEz0LSCnS7_DFovgePJjTyfqwMdsiaCgwMeta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/print-projects/[file_id].vue?macro=true";
import { default as print_45projectsBanSqfLVKzNnx7pUn7CZBYb__FK7Wdt0C_nWFA3R_c8Meta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/print-projects.vue?macro=true";
import { default as indexCb67c7mH5tlaw6kjIT7jA9LscU_45Q7uRRaAApwU0YPB0Meta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/timeline/index.vue?macro=true";
import { default as _91file_id_93Ld0Tp_45Ajhj1GkusbBbrAoKXhFBvnC_B7LjMLWpyIt0IMeta } from "/tmp/build_5b96a0a9/pages/digitization-projects/[box_id]/[[share_token]]/files/[file_id].vue?macro=true";
import { default as _91_91share_token_93_93IfGHiz1SdgYbhbFaL1ISopwsuyeSeT_45UR_45UwcatHJ8wMeta } from "/tmp/build_5b96a0a9/pages/digitization-projects/[box_id]/[[share_token]].vue?macro=true";
import { default as _91share_token_93XjR7xm_45Lk_45ThsColWaohqA6fDl0E6u460NEQ1wkzifsMeta } from "/tmp/build_5b96a0a9/pages/external/embed/[user_id]/[file_id]/[share_token].vue?macro=true";
import { default as _91file_id_93kF8_n57no0cMe7itvXPjdx96V4dH5dQMBlOq_uE44UgMeta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/timeline/period/[period_id]/file/[file_id].vue?macro=true";
import { default as _91period_id_93e2aq9zVwedelJBGt2nI8isfs9iPq4rolCHiIMlopyIQMeta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/timeline/period/[period_id].vue?macro=true";
import { default as _91_91share_token_93_93WLBVaPhVCW5TGsbirxeufrx_LIbCfklcp8UsBlwqeNAMeta } from "/tmp/build_5b96a0a9/pages/digitization-projects/files/[file_id]/[[share_token]].vue?macro=true";
import { default as _91_91share_token_93_93_45AQbULrUJ1ap7R_45W5nt4jnolGv5fxGSKL98Ph6aZj0oMeta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/files/[file_id]/[[share_token]].vue?macro=true";
import { default as _91file_id_93WmzKClp_45R3PWV8QLvOlbhJE23_45ZEfkuBVkrxwjSasD0Meta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/tags/[tag_id_or_slug]/[[share_token]]/files/[file_id].vue?macro=true";
import { default as _91_91share_token_93_93GTLI6ke_450IyR1Xxm_45vksoXMS_45e7t9eMSlkjmBrC1EDwMeta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/tags/[tag_id_or_slug]/[[share_token]].vue?macro=true";
import { default as _91file_id_93nSYmmJmW41tFVLLBG2uiZJlVxyPRM4TwFEFOt_458Jp64Meta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/albums/[album_id_or_slug]/[[share_token]]/files/[file_id].vue?macro=true";
import { default as _91_91share_token_93_93YhPO2_45ZZLAu7tKv8JCzRaXCtpPv3HKrZ6KXYna6NW9sMeta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/albums/[album_id_or_slug]/[[share_token]].vue?macro=true";
import { default as _91file_id_93CTdLUU5PhfKI2V_rX26NtIEbTtdUw7psk9ypI6NeO5kMeta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/people/[person_id_or_slug]/[[share_token]]/files/[file_id].vue?macro=true";
import { default as _91_91share_token_93_93KMwxViGEDagX7QqXrCSlC5j4Rjy1_45cl8mHzbZoKULeEMeta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/people/[person_id_or_slug]/[[share_token]].vue?macro=true";
import { default as _91file_id_93_45tuxkfiS8_453_LnGyqwdwtYrZ_cWgJODLXAYHiDQXC5UMeta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/containers/[container_id_or_slug]/[[share_token]]/files/[file_id].vue?macro=true";
import { default as _91_91share_token_93_93zcx1IpsJoXxZr6zRQxp9pt5ekxtiOc3wVzV1F_wFzjsMeta } from "/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/containers/[container_id_or_slug]/[[share_token]].vue?macro=true";
import { default as component_45stubyEbd_45qkfOypX4Wh6adWCJt3twSIS4JuUf_45HdXGE_iDEMeta } from "/tmp/build_5b96a0a9/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubyEbd_45qkfOypX4Wh6adWCJt3twSIS4JuUf_45HdXGE_iDE } from "/tmp/build_5b96a0a9/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "all",
    path: "/all",
    meta: allF7H13m353bRLTeFDfG2ud0YYtAAi58HwEFTy3PWG6_45gMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/all.vue"),
    children: [
  {
    name: "all-file_id",
    path: ":file_id()",
    meta: _91file_id_93MqZVlPlJSoMMIOZ4KDc0ihFnz3tF6mADbwKDL6BbAtoMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/all/[file_id].vue")
  }
]
  },
  {
    name: homelrma2NC5Bh2pNtb1_PWm3NRBhX3QyR9tuavc3reWrSYMeta?.name,
    path: "/engage",
    meta: homelrma2NC5Bh2pNtb1_PWm3NRBhX3QyR9tuavc3reWrSYMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/home.vue"),
    children: [
  {
    name: "home",
    path: "",
    component: () => import("/tmp/build_5b96a0a9/pages/home/index.vue")
  },
  {
    name: "home-on-this-day",
    path: "on-this-day",
    component: () => import("/tmp/build_5b96a0a9/pages/home/on-this-day.vue"),
    children: [
  {
    name: "home-on-this-day-files-file_id",
    path: "files/:file_id()",
    meta: _91file_id_93n8yPS2lCy7jgjSCpBaouxYIxF9gXfWGPtEj2iuwrtPIMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/home/on-this-day/files/[file_id].vue")
  }
]
  },
  {
    name: "home-recent-days",
    path: "recent-days",
    component: () => import("/tmp/build_5b96a0a9/pages/home/recent-days.vue"),
    children: [
  {
    name: "home-recent-days-files-file_id",
    path: "files/:file_id()",
    meta: _91file_id_93YuzssgCeFXVXqKueWiZG_xbDVrjwQc2LgXVOv_V1akoMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/home/recent-days/files/[file_id].vue")
  }
]
  },
  {
    name: "home-favorites-file_id",
    path: "favorites/:file_id()",
    meta: _91file_id_93OC1F8q3blLNziIzeRF2XoIfg8LAkqCOgDej4pbRx_UgMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/home/favorites/[file_id].vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    meta: index2lg8qu_kDpykCCtHE59zs1xGRb47clF3Q6eVCvsjQwwMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/index.vue")
  },
  {
    name: "gallery",
    path: "/gallery",
    component: () => import("/tmp/build_5b96a0a9/pages/gallery.vue")
  },
  {
    name: "sign_in",
    path: "/sign_in",
    meta: sign_inyUgoOPYA_459oma9V62eL_45lpTWrrHWBQ3pKva1U_45sxKYQMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/sign_in.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    meta: welcomeMbFn0wHfKXXQ7ycYTAFr38DDdpOPtrEv2eeB1tDAlDYMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/welcome.vue")
  },
  {
    name: "projects",
    path: "/projects",
    meta: projectsDlDUM1_45q_6soQErXPfMaFkSag7YwK_45OpUEOj6Okim7wMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/projects.vue")
  },
  {
    name: "groups",
    path: "/groups",
    meta: indexIToekD7w4WXZZDAyk86CmbpZpv8Yk5P1uET0wbCFQFYMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/groups/index.vue")
  },
  {
    name: "delete-bin",
    path: "/delete-bin",
    meta: indexHe_zj148C7yZu_45daL9EpW2nmjfhqJgTFQvXF_45xrAcMUMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/delete-bin/index.vue")
  },
  {
    name: "connections",
    path: "/connections",
    meta: indexvvjABqlY0gdWHNICy87UKDkRide2hUmrKRW5EZXiob0Meta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/connections/index.vue")
  },
  {
    name: "impersonate-id",
    path: "/impersonate/:id?",
    meta: _91_91id_93_93DyIoAWClDwUp2QfUtMukxz1ism_45bzO5M_45O8dIAVLH_450Meta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/impersonate/[[id]].vue")
  },
  {
    name: "framed-photo-prints",
    path: "/framed-photo-prints",
    meta: framed_45photo_45printsVnLoODuv0voinTq6KlkqVqA_oWcgdiIP5Ks9j2IeSZYMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/framed-photo-prints.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: index1wYfmHCUQK5SH9NMOYxcPqlQbDSGhN9PfOc_45JKrGWm4Meta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/notifications/index.vue")
  },
  {
    name: "digitization-projects",
    path: "/digitization-projects",
    meta: indexKu1bdH70b80J3RzO1Zc7TR6l_QMMM55M8Vz7rdggu48Meta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/digitization-projects/index.vue")
  },
  {
    name: "users-user_id_or_slug-token",
    path: "/users/:user_id_or_slug()/:token?",
    meta: _91_91token_93_93UvYPeFyA_458xYeXK53c72oV2THdVRqQzVZ4rN5sV_wJ0Meta || {},
    alias: ["/invite/:user_id_or_slug()/:token?"],
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/[[token]].vue")
  },
  {
    name: "users-user_id_or_slug-tags",
    path: "/users/:user_id_or_slug()/tags",
    meta: indexE_74Hd271Elmrpt8bkvPqIpKncB_JDtCjDQzYqwHUNYMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/tags/index.vue")
  },
  {
    name: "users-user_id_or_slug-albums",
    path: "/users/:user_id_or_slug()/albums",
    meta: indexL08TFl7uKtfZXqMFirVh_456SjAHqQEh5M0_45zMPo22_45IsMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/albums/index.vue")
  },
  {
    name: "users-user_id_or_slug-people",
    path: "/users/:user_id_or_slug()/people",
    meta: indexQGvPCllM9CEC2voCMYThYxLMGAgJXuzoDKaxwlwvLJwMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/people/index.vue")
  },
  {
    name: "users-user_id_or_slug-albums-recent",
    path: "/users/:user_id_or_slug()/albums/recent",
    meta: recentBeHqQbGas8VQwTx73TD_458XEJmxEmW3HT3NXUViq7q8IMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/albums/recent.vue")
  },
  {
    name: "users-user_id_or_slug-albums-visited",
    path: "/users/:user_id_or_slug()/albums/visited",
    meta: visited_hZh1r56Wf2AVnT0EB1sWWdJOeS8NnQaBJeV4OtYeXkMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/albums/visited.vue")
  },
  {
    name: "users-user_id_or_slug-print-projects",
    path: "/users/:user_id_or_slug()/print-projects",
    meta: print_45projectsBanSqfLVKzNnx7pUn7CZBYb__FK7Wdt0C_nWFA3R_c8Meta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/print-projects.vue"),
    children: [
  {
    name: "users-user_id_or_slug-print-projects-file_id",
    path: ":file_id()",
    meta: _91file_id_93w3a7GSZZeoGEz0LSCnS7_DFovgePJjTyfqwMdsiaCgwMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/print-projects/[file_id].vue")
  }
]
  },
  {
    name: "users-user_id_or_slug-timeline",
    path: "/users/:user_id_or_slug()/timeline",
    meta: indexCb67c7mH5tlaw6kjIT7jA9LscU_45Q7uRRaAApwU0YPB0Meta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/timeline/index.vue")
  },
  {
    name: "digitization-projects-box_id-share_token",
    path: "/digitization-projects/:box_id()/:share_token?",
    component: () => import("/tmp/build_5b96a0a9/pages/digitization-projects/[box_id]/[[share_token]].vue"),
    children: [
  {
    name: "digitization-projects-box_id-share_token-files-file_id",
    path: "files/:file_id()",
    meta: _91file_id_93Ld0Tp_45Ajhj1GkusbBbrAoKXhFBvnC_B7LjMLWpyIt0IMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/digitization-projects/[box_id]/[[share_token]]/files/[file_id].vue")
  }
]
  },
  {
    name: "external-embed-user_id-file_id-share_token",
    path: "/external/embed/:user_id()/:file_id()/:share_token()",
    component: () => import("/tmp/build_5b96a0a9/pages/external/embed/[user_id]/[file_id]/[share_token].vue")
  },
  {
    name: "users-user_id_or_slug-timeline-period-period_id",
    path: "/users/:user_id_or_slug()/timeline/period/:period_id()",
    meta: _91period_id_93e2aq9zVwedelJBGt2nI8isfs9iPq4rolCHiIMlopyIQMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/timeline/period/[period_id].vue"),
    children: [
  {
    name: "users-user_id_or_slug-timeline-period-period_id-file-file_id",
    path: "file/:file_id()",
    meta: _91file_id_93kF8_n57no0cMe7itvXPjdx96V4dH5dQMBlOq_uE44UgMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/timeline/period/[period_id]/file/[file_id].vue")
  }
]
  },
  {
    name: "digitization-projects-files-file_id-share_token",
    path: "/digitization-projects/files/:file_id()/:share_token?",
    meta: _91_91share_token_93_93WLBVaPhVCW5TGsbirxeufrx_LIbCfklcp8UsBlwqeNAMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/digitization-projects/files/[file_id]/[[share_token]].vue")
  },
  {
    name: "users-user_id_or_slug-files-file_id-share_token",
    path: "/users/:user_id_or_slug()/files/:file_id()/:share_token?",
    meta: _91_91share_token_93_93_45AQbULrUJ1ap7R_45W5nt4jnolGv5fxGSKL98Ph6aZj0oMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/files/[file_id]/[[share_token]].vue")
  },
  {
    name: "users-user_id_or_slug-tags-tag_id_or_slug-share_token",
    path: "/users/:user_id_or_slug()/tags/:tag_id_or_slug()/:share_token?",
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/tags/[tag_id_or_slug]/[[share_token]].vue"),
    children: [
  {
    name: "users-user_id_or_slug-tags-tag_id_or_slug-share_token-files-file_id",
    path: "files/:file_id()",
    meta: _91file_id_93WmzKClp_45R3PWV8QLvOlbhJE23_45ZEfkuBVkrxwjSasD0Meta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/tags/[tag_id_or_slug]/[[share_token]]/files/[file_id].vue")
  }
]
  },
  {
    name: "users-user_id_or_slug-albums-album_id_or_slug-share_token",
    path: "/users/:user_id_or_slug()/albums/:album_id_or_slug()/:share_token?",
    meta: _91_91share_token_93_93YhPO2_45ZZLAu7tKv8JCzRaXCtpPv3HKrZ6KXYna6NW9sMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/albums/[album_id_or_slug]/[[share_token]].vue"),
    children: [
  {
    name: "users-user_id_or_slug-albums-album_id_or_slug-share_token-files-file_id",
    path: "files/:file_id()",
    meta: _91file_id_93nSYmmJmW41tFVLLBG2uiZJlVxyPRM4TwFEFOt_458Jp64Meta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/albums/[album_id_or_slug]/[[share_token]]/files/[file_id].vue")
  }
]
  },
  {
    name: "users-user_id_or_slug-people-person_id_or_slug-share_token",
    path: "/users/:user_id_or_slug()/people/:person_id_or_slug()/:share_token?",
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/people/[person_id_or_slug]/[[share_token]].vue"),
    children: [
  {
    name: "users-user_id_or_slug-people-person_id_or_slug-share_token-files-file_id",
    path: "files/:file_id()",
    meta: _91file_id_93CTdLUU5PhfKI2V_rX26NtIEbTtdUw7psk9ypI6NeO5kMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/people/[person_id_or_slug]/[[share_token]]/files/[file_id].vue")
  }
]
  },
  {
    name: "users-user_id_or_slug-containers-container_id_or_slug-share_token",
    path: "/users/:user_id_or_slug()/containers/:container_id_or_slug()/:share_token?",
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/containers/[container_id_or_slug]/[[share_token]].vue"),
    children: [
  {
    name: "users-user_id_or_slug-containers-container_id_or_slug-share_token-files-file_id",
    path: "files/:file_id()",
    meta: _91file_id_93_45tuxkfiS8_453_LnGyqwdwtYrZ_cWgJODLXAYHiDQXC5UMeta || {},
    component: () => import("/tmp/build_5b96a0a9/pages/users/[user_id_or_slug]/containers/[container_id_or_slug]/[[share_token]]/files/[file_id].vue")
  }
]
  },
  {
    name: component_45stubyEbd_45qkfOypX4Wh6adWCJt3twSIS4JuUf_45HdXGE_iDEMeta?.name,
    path: "/library",
    component: component_45stubyEbd_45qkfOypX4Wh6adWCJt3twSIS4JuUf_45HdXGE_iDE
  },
  {
    name: component_45stubyEbd_45qkfOypX4Wh6adWCJt3twSIS4JuUf_45HdXGE_iDEMeta?.name,
    path: "/static/images/forever-album-no-cover.png",
    component: component_45stubyEbd_45qkfOypX4Wh6adWCJt3twSIS4JuUf_45HdXGE_iDE
  }
]